export const SITE = {
  name: "Pharma360",
  tagline: "Votre Parapharmacie en Ligne en Algérie",
  phone: "0550 36 03 60",
  phoneLink: "+213550360360",
  email: "contact@pharma360-dz.com",
  address: "12 Boulevard Mohamed V, Alger Centre, Algérie",
  horaires: "7j/7 — 08h00 à 22h00",
  socials: {
    facebook: "#",
    instagram: "#",
    tiktok: "#",
  },
};

export const CATEGORIES = [
  { id: "sante", label: "Santé", icon: "HeartPulse" },
  { id: "visage", label: "Visage", icon: "Sparkles" },
  { id: "corps", label: "Corps", icon: "UserCheck" },
  { id: "cheveux", label: "Cheveux", icon: "Scissors" },
  { id: "hygiene", label: "Hygiène", icon: "ShieldCheck" },
  { id: "bebe-maman", label: "Bébé & Maman", icon: "Baby" },
  { id: "solaire", label: "Solaire", icon: "Sun" },
  { id: "homme-sport", label: "Homme & Sport", icon: "Dumbbell" },
  { id: "complements", label: "Compléments alimentaires", icon: "Pill" },
  { id: "minceur", label: "Minceur", icon: "Activity" },
  { id: "nature-bio", label: "Nature & Bio", icon: "Leaf" },
  { id: "animaux", label: "Animaux", icon: "PawPrint" },
  { id: "materiel-medical", label: "Matériel Médical", icon: "Stethoscope" },
];

export const WILAYAS = [
  "Adrar","Chlef","Laghouat","Oum El Bouaghi","Batna","Béjaïa","Biskra","Béchar","Blida","Bouira",
  "Tamanrasset","Tébessa","Tlemcen","Tiaret","Tizi Ouzou","Alger","Djelfa","Jijel","Sétif","Saïda",
  "Skikda","Sidi Bel Abbès","Annaba","Guelma","Constantine","Médéa","Mostaganem","M'Sila","Mascara","Ouargla",
  "Oran","El Bayadh","Illizi","Bordj Bou Arréridj","Boumerdès","El Tarf","Tindouf","Tissemsilt","El Oued","Khenchela",
  "Souk Ahras","Tipaza","Mila","Aïn Defla","Naâma","Aïn Témouchent","Ghardaïa","Relizane",
];

export const CATEGORY_IMAGES = {
  sante: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=500",
  visage: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=500",
  corps: "https://images.unsplash.com/photo-1612817288484-6f916006741a?w=500",
  cheveux: "https://images.unsplash.com/photo-1522337660859-02fbefca4702?w=500",
  hygiene: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=500",
  "bebe-maman": "https://images.unsplash.com/photo-1778276551433-75420636007d?w=500",
  solaire: "https://images.unsplash.com/photo-1556228841-a3c527ebefe5?w=500",
  "homme-sport": "https://images.unsplash.com/photo-1669322779651-5ca89652492e?w=500",
  complements: "https://images.unsplash.com/photo-1664956618021-73c47736845e?w=500",
  minceur: "https://images.unsplash.com/photo-1523901839036-a3030662f220?w=500",
  "nature-bio": "https://images.unsplash.com/photo-1760108249194-f9cafd970762?w=500",
  animaux: "https://images.unsplash.com/photo-1571873735645-1ae72b963024?w=500",
  "materiel-medical": "https://images.unsplash.com/photo-1700832082200-af7deeb63d9b?w=500",
};
